var map = {
	"./template.bet575": 2035,
	"./template.bet575.tsx": 2035,
	"./template.bet777": 2036,
	"./template.bet777.tsx": 2036,
	"./template.betbetbet": 2001,
	"./template.betbetbet.tsx": 2001,
	"./template.betgalaxy": 1160,
	"./template.betgalaxy.tsx": 1160,
	"./template.betprofessor": 2037,
	"./template.betprofessor.tsx": 2037,
	"./template.betroyale": 2038,
	"./template.betroyale.tsx": 2038,
	"./template.betstride": 2039,
	"./template.betstride.tsx": 2039,
	"./template.buffalobet": 2040,
	"./template.buffalobet.tsx": 2040,
	"./template.chromabet": 2041,
	"./template.chromabet.tsx": 2041,
	"./template.default": 664,
	"./template.default.tsx": 664,
	"./template.epicodds": 2042,
	"./template.epicodds.tsx": 2042,
	"./template.fiestabet": 2002,
	"./template.fiestabet.tsx": 2002,
	"./template.forsport": 1161,
	"./template.forsport.tsx": 1161,
	"./template.gigabet": 2043,
	"./template.gigabet.tsx": 2043,
	"./template.goldenbet888": 1989,
	"./template.goldenbet888.tsx": 1989,
	"./template.goldenrush": 2044,
	"./template.goldenrush.tsx": 2044,
	"./template.hyperbet": 2045,
	"./template.hyperbet.tsx": 2045,
	"./template.juicybet": 2046,
	"./template.juicybet.tsx": 2046,
	"./template.junglebet": 2047,
	"./template.junglebet.tsx": 2047,
	"./template.magnumbet": 2048,
	"./template.magnumbet.tsx": 2048,
	"./template.oldgill": 2003,
	"./template.oldgill.tsx": 2003,
	"./template.puntcity": 2004,
	"./template.puntcity.tsx": 2004,
	"./template.puntgenie": 2049,
	"./template.puntgenie.tsx": 2049,
	"./template.pyramidbet": 1990,
	"./template.pyramidbet.tsx": 1990,
	"./template.questbet": 2005,
	"./template.questbet.tsx": 2005,
	"./template.slambet": 2006,
	"./template.slambet.tsx": 2006,
	"./template.sterlingparker": 1162,
	"./template.sterlingparker.tsx": 1162,
	"./template.sugarcastle": 2050,
	"./template.sugarcastle.tsx": 2050,
	"./template.templebet": 2051,
	"./template.templebet.tsx": 2051,
	"./template.titanbet": 2052,
	"./template.titanbet.tsx": 2052,
	"./template.ts": 383,
	"./template.vikingbet": 2007,
	"./template.vikingbet.tsx": 2007,
	"./template.volcanobet": 1987,
	"./template.volcanobet.tsx": 1987,
	"./template.wellbet": 2053,
	"./template.wellbet.tsx": 2053
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2438;